import { get, isObject, set } from "radashi";
import { PhysicalType } from "../units/constants";
import {
  DefinitionRecord,
  FieldDefinition,
  FieldValues,
  isFieldDefinition,
} from "./fieldDefinitions/definitions";
import { processNumericValue } from "./processNumericValue";

type ExtractDefaultValuesOptions = {
  conversionFn?: (value: number, unitType: PhysicalType) => number;
  round?: boolean;
};

export const extractDefaultValues = <TDefinitions extends object>(
  definitions: TDefinitions,
  options: ExtractDefaultValuesOptions = {},
): FieldValues<TDefinitions> =>
  Object.keys(definitions).reduce<FieldValues<TDefinitions>>(
    (acc, groupKey) => {
      const settingVal = get<
        DefinitionRecord | FieldDefinition | FieldDefinition[]
      >(definitions, groupKey);

      if (Array.isArray(settingVal)) {
        const list = settingVal.map((definition) =>
          processNumericValue(definition.default, definition, options),
        );
        return set(acc, groupKey, list);
      }

      if (!isFieldDefinition(settingVal) && isObject(settingVal)) {
        return set(
          acc,
          groupKey,
          extractDefaultValues(settingVal as TDefinitions, options),
        );
      }

      return set(
        acc,
        groupKey,
        processNumericValue(settingVal.default, settingVal, options),
      );
    },
    {} as FieldValues<TDefinitions>,
  );
